import { LegacyRef, Ref } from "react";

export function legacyToStandardRef<T>(
  ref: LegacyRef<T> | undefined,
): Ref<T> | undefined {
  return typeof ref !== "string" ? ref : undefined;
}
